module.exports = __webpack_public_path__ + "static/media/VerifyIcon.2431cefd.svg";